export enum TrendGranularity {
  month = 'MONTH',
  quarter = 'QUARTER',
  year = 'YEAR',
}
